<ng-container *ngIf="model.isSuccessful; else notSuccessfulTitleSection">
  <h1 mat-dialog-title>{{ model.successfulTitle }}</h1>
</ng-container>

<ng-template #notSuccessfulTitleSection>
  <h1 mat-dialog-title>{{ model.unsuccessfulTitle }}</h1>
</ng-template>

<div mat-dialog-content>
  <ng-container *ngIf="!model.isSuccessful">
    <ul>
      <li *ngFor="let errorDescription of model.errorDescriptions">
        {{ errorDescription }}
      </li>
    </ul>
  </ng-container>
</div>

<div mat-dialog-actions class="dialog-action">
  <button mat-button [mat-dialog-close]="true">{{ closeLabel }}</button>
</div>
